import React from 'react';
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Tooltip,
} from '@mui/material';

interface ExpandableSectionProps {
  title: string;
  toggleAll?: boolean;
  onToggleAll?: (checked: boolean) => void;
  showToggle?: boolean;
  showMoreButton?: boolean;
  moreButtonTooltip?: string;
  children: React.ReactNode;
}

const ExpandableSection: React.FC<ExpandableSectionProps> = ({
  title,
  toggleAll = false,
  onToggleAll,
  showToggle = false,
  showMoreButton = false,
  moreButtonTooltip = 'More options coming soon',
  children,
}) => {
  const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onToggleAll) {
      onToggleAll(event.target.checked);
    }
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">{title}</Typography>
        {showToggle && (
          <FormControlLabel
            control={<Switch checked={toggleAll} onChange={handleToggleChange} />}
            label="Toggle All"
          />
        )}
      </Box>

      {children}

      {showMoreButton && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 2,
          }}
        >
          <Tooltip
            title={moreButtonTooltip}
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: 'background.paper',
                  color: 'text.primary',
                  border: '1px solid',
                  borderColor: 'divider',
                  fontSize: '0.875rem',
                },
              },
              arrow: {
                sx: {
                  color: 'background.paper',
                  '&::before': {
                    border: '1px solid',
                    borderColor: 'divider',
                  },
                },
              },
            }}
          >
            <Typography
              sx={{
                cursor: 'pointer',
                color: '#32CA1D',
                fontWeight: 500,
                fontSize: '0.9rem',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  opacity: 0.8,
                  textDecoration: 'underline',
                },
              }}
            >
              Load More
            </Typography>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

export default ExpandableSection;
